<template>
  <div class="text-center" >
    <v-dialog v-model="dialog" max-width="660" persistent>
      <v-card class="conf-card" tile>
        <v-card-title class="conf-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="36" class="elevation-1">
              <v-icon color="deep-orange darken-3">mdi-shield-check</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 white--text">Confirmar solicitud de pre inscripcion</div>
              <div class="text-body-2 white--text">
                Esta accion debe ser revisada por contabilidad
              </div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-alert type="warning" border="left" colored-border class="mb-4">
            Al confirmar, la solicitud sera revisada por el area contable  y se procede a
            <b>generar su recibo por el monto del comprobante</b>. Si cumple los requisitos contables minimos
            el sistema cambia automaticamente a <b>inscrito</b> si no cumple entonces se considera un <b>pre inscrito</b>.
          </v-alert>

          <v-card outlined class="pa-3 mb-3">
            <div class="text-subtitle-2 mb-1">Resumen de envio</div>
            <div class="text-body-2 text--secondary"><b>Programa:</b> {{ resumen.programa }}</div>
            <div class="text-body-2 text--secondary"><b>Estudiante:</b> {{ resumen.estudiante }}</div>
            <div class="text-body-2 text--secondary"><b>Plan:</b> {{ resumen.plan }}</div>
            <div class="text-body-2 text--secondary"><b>Tipo inscripcion:</b> {{ resumen.tipo_inscripcion }}</div>
            <div class="text-body-2 text--secondary"><b>Promocion:</b> {{ resumen.promocion }}</div>
            
            <div v-if="resumen.convenio" class="text-body-2 text--secondary"><b>Institución convenio:</b> {{ resumen.convenio }}</div>
            <div v-if="resumen.modulos && resumen.modulos.length" class="text-body-2 text--secondary">
              <b>Módulos:</b> {{ resumen.modulos.join(', ') }}
            </div>
          </v-card>

          <div class="d-flex align-center justify-space-between mb-2">
            <div class="text-subtitle-2">Plan de pagos generado</div>
            <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3">
              {{ resumen.cuotas }} items
            </v-chip>
          </div>
          <v-data-table
            :headers="headers"
            :items="resumen.plan_pagos"
            :item-class="rowClass"
            dense
            disable-pagination
            hide-default-footer
            class="elevation-1"
            no-data-text="No se generaron cuotas"
          />

          <v-divider class="my-3"></v-divider>

          <v-row dense>
            <v-col cols="12" sm="5">
              <v-card outlined class="pa-2">
                <div class="text-body-2 text--secondary">Comprobante de pago</div>
                <v-chip small :color="resumen.comprobante ? 'green lighten-5' : 'red lighten-5'"
                        :class="resumen.comprobante ? 'green--text text--darken-3' : 'red--text text--darken-3'">
                  {{ resumen.comprobante ? 'Adjunto' : 'No adjunto' }}
                </v-chip>
              </v-card>
            </v-col>
            <v-col cols="12" sm="7">
              <v-card outlined class="pa-2">
                <div class="text-body-2 text--secondary">Datos para la factura</div>
                <div v-if="resumen.factura && resumen.factura.razon_social"> 
                  <p class="my-0"> <b>Razon social:</b> {{ resumen.factura.razon_social }} </p>
                  <p class="my-0"> <b>Numero documento:</b> {{ resumen.factura.numero_documento }} {{ resumen.factura.complemento }} </p>
                  <p class="my-0"> <b>Correo:</b> {{ resumen.factura.email }} </p>
                  <p class="my-0"> <b>Tipo documento:</b> {{ resumen.factura.tipo_documento?.descripcion_SIN }} </p>
                </div>
                <v-chip v-else small color="red lighten-5" class="red--text text--darken-3">
                  No adjunto
                </v-chip>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrar()">
            <v-icon small left>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn color="green" class="white--text" @click="guardar()">
            <v-icon small left>mdi-check</v-icon>
            Confirmar solicitud
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { headers, rowClassX } from './utils';
export default {
  data() {
    return {
      dialog: false,
      resolvePromise: null,
      resumen: {
        programa: '',
        estudiante: '',
        plan: '',
        promocion: 'Sin promocion',
        convenio: null,
        modulos: [],
        plan_pagos: [],
        cuotas: 0,
        comprobante: false,
        documento: false,
        factura: {}
      },
      headers: headers,
    };
  },
  methods: {
    openmodal(payload = {}) {
      this.resumen = {
        ...this.resumen,
        ...payload,
        plan_pagos: payload.plan_pagos || [],
        cuotas: payload.plan_pagos ? payload.plan_pagos.length : 0,
      };
      this.dialog = true;
      return new Promise((resolve) => {
        this.resolvePromise = resolve;
      });
    },
    rowClass(item) {
      return rowClassX(item);
    },
    cerrar() {
      this.resolvePromise(false);
      this.dialog = false;
    },
    guardar() {
      this.resolvePromise(true);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.conf-card {
  border-radius: 14px;
  overflow: hidden;
}
.conf-hero {
  background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
}
::v-deep .grupo-par {
  background-color: #fcfcfc !important;
}
::v-deep .grupo-impar {
  background-color: #f1f5ff !important;
}
</style>
